import { useState, useEffect } from 'react';
import Modal from './Modal';
import { Save, Phone, Building } from 'lucide-react';
import CitySelectorForm from '../../inputs/CitySelectorForm';

const ClientFormModal = ({ isOpen, onClose, onSave, client }) => {
  
  const [formData, setFormData] = useState({
    nume_firma: '',
    email: '',
    telefon: '',
    cui: '',
    adresa: '',
    oras: '',
    notes: ''
  });

  useEffect(() => {
    if (client) {
      setFormData({
        nume_firma: client.nume_firma || '',
        email: client.email || '',
        telefon: client.telefon || '',
        cui: client.cui || '',
        adresa: client.adresa || '',
        oras: client.oras || '',
        notes: client.notes || ''
      });
    } else {
      setFormData({
        nume_firma: '',
        email: '',
        telefon: '',
        cui: '',
        adresa: '',
        oras: '',
        notes: ''
      });
    }
  }, [client]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    onSave(formData);
    onClose();
  };

  return (
    <Modal isOpen={isOpen} onClose={onClose} title={client ? 'Editează Client' : 'Adaugă Client'}>
      <form onSubmit={handleSubmit} className="space-y-4">
        {/* Nume firmă */}
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1">Nume firmă</label>
          <div className="flex items-center border rounded-md p-2">
            <Building className="w-5 h-5 text-gray-400 mr-2" />
            <input
              type="text"
              name="nume_firma"
              value={formData.nume_firma}
              onChange={handleChange}
              required
              className="w-full border-none focus:ring-0"
              placeholder="Nume firmă"
            />
          </div>
        </div>

        {/* CUI */}
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1">CUI</label>
          <input
            type="text"
            name="cui"
            value={formData.cui}
            onChange={handleChange}
            className="w-full border border-gray-300 rounded-md p-2"
            placeholder="Cod Unic de Înregistrare"
          />
        </div>

        {/* Email */}
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1">Email</label>
          <input
            type="email"
            name="email"
            value={formData.email}
            onChange={handleChange}
            className="w-full border border-gray-300 rounded-md p-2"
            placeholder="exemplu@email.com"
          />
        </div>

        {/* Telefon */}
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1">Telefon</label>
          <div className="flex items-center border rounded-md p-2">
            <Phone className="w-5 h-5 text-gray-400 mr-2" />
            <input
              type="tel"
              name="telefon"
              value={formData.telefon}
              onChange={handleChange}
              className="w-full border-none focus:ring-0"
              placeholder="0740 123 456"
            />
          </div>
        </div>

        {/* Adresă */}
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1">Adresă</label>
          <input
            type="text"
            name="adresa"
            value={formData.adresa}
            onChange={handleChange}
            className="w-full border border-gray-300 rounded-md p-2"
            placeholder="Stradă, număr, etc."
          />
        </div>

        {/* Oraș */}
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1">Oraș</label>
          <CitySelectorForm
              selectedCity={formData.oras} // Fixed: pass the actual city value
              onCityChange={(city) => {
                if (typeof city === 'string') {
                  // Handle string input (for manual typing)
                  setFormData(prev => ({
                    ...prev,
                    oras: city,
                    judet: '', // Clear county if manually typed
                  }));
                } else {
                  // Handle city object from selector
                  setFormData(prev => ({
                    ...prev,
                    oras: city.name,
                    judet: city.county,
                    cod_judet: city.countyCode,
                  }));
                }
              }}
            />


        </div>

        {/* Notițe */}
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1">Notițe (Opțional)</label>
          <textarea
            name="notes"
            value={formData.notes}
            onChange={handleChange}
            rows={3}
            className="w-full border border-gray-300 rounded-md p-2"
            placeholder="Observații suplimentare"
          />
        </div>

        {/* Buton salvare */}
        <button
          type="submit"
          className="w-full bg-gradient-to-r from-orange-500 to-red-500 text-white py-2 rounded-xl flex justify-center items-center hover:from-orange-600 hover:to-red-600 transition-colors"
        >
          <Save className="w-5 h-5 mr-2" /> Salvează
        </button>
      </form>
    </Modal>
  );
};

export default ClientFormModal;
